export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7905.f64b1e19.jpg";